import { Address } from "./Address";

export class Applicant{
    id: string; //onfido's applicant id value
    first_name: string;
    last_name: string;
    dob: string;
    email: string;
    address: Address;    
}